import React, { useEffect, useRef, useState } from 'react';
import { Grid, Button, Box, Typography, useMediaQuery, Container, IconButton, Drawer, MenuItem, Divider, useTheme } from '@mui/material';
import { useLanguage } from '../LanguageContext';
import { t } from '../utils/translationUtils';
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import translations from '../translations';

const Contact_us = () => {
  const navigate = useNavigate();
  const { language, switchLanguage } = useLanguage();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const formRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Create a helper function to safely access translations
  const getTranslation = (key) => {
    if (translations[key] && translations[key][language]) {
      return translations[key][language];
    }
    // Fallback to direct key values if structured translations don't exist
    return key;
  };
  
  const handleApriIlConto = () => {
    window.open('https://my.crhmoney.com/register', '_blank');
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      if (window.hbspt) {
        const formParams = language === 'en'
          ? {
              region: "eu1",
              portalId: "25343058",
              formId: "bdc0c0b2-8ae6-444b-bff4-413959274b3a",
              target: "#hubspotForm"
            }
          : {
              portalId: "25343058",
              formId: "0633558f-bfd7-4e30-b190-cbf7481e7333",
              target: "#hubspotForm"
            };

        window.hbspt.forms.create(formParams);
      }
    });
  }, [language]);

  return (
    <>
      {/* Top navigation bar with white background */}
      <Box sx={{
        backgroundColor: '#ffffff',
        color: '#000000',
        width: '100%',
        position: 'relative'
      }}>
        <Box
          sx={{
            width: '100%',
            backgroundColor: '#ffffff',
            padding: '20px',
            display: { xs: 'block', md: 'block', lg: 'block', xl: 'flex' }
          }}
        >
          {/* Left half - Logo */}
          <Box sx={{
            width: { xs: '100%', xl: '50%' },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <img
              src="/images/logog.svg"
              alt={t("HomeNav1", translations, language)}
              style={{
                height: '200px',
                maxWidth: '100%',
                objectFit: 'contain'
              }}
            />
          </Box>

          {/* Right half - Navigation and buttons */}
          <Box sx={{
            width: { xs: '100%', xl: '50%' },
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'column',
            gap: '30px',
            justifyContent: 'center',
            alignItems: 'center',
            mt: { md: 3, xl: 0 }  // Add margin-top when in stacked layout
          }}>
            {/* Top row - Account, Access, Language */}
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '30px'
            }}>
              {/* Open Account */}
              <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={handleApriIlConto}>
                <img src="/images/Navbar2.webp" alt="Open Account" style={{ width: '70px', marginRight: '12px' }} />
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '24px' },
                    color: '#000000'
                  }}
                >
                  {t("HomeNav2", translations, language)}
                </Typography>
              </Box>

              {/* Client Access */}
              <Box
                sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                onClick={() => window.open('https://my.crhmoney.com', '_blank')}
              >
                <img src="/images/Navbar3.webp" alt="Client Access" style={{ width: '70px', marginRight: '12px' }} />
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '24px' },
                    color: '#000000'
                  }}
                >
                  {t("HomeNav3", translations, language)}
                </Typography>
              </Box>

              {/* Language Selector */}
              <Box
                onClick={() => switchLanguage(language === 'en' ? 'it' : 'en')}
                sx={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {language === 'en' ? (
                  <img src="/images/Usa.svg" alt="English" style={{ width: '36px' }} />
                ) : (
                  <img src="/images/Ita.svg" alt="Italian" style={{ width: '36px' }} />
                )}
              </Box>
            </Box>

            {/* Bottom row - Navigation buttons */}
            <Box sx={{
              display: 'flex',
              gap: '10px', 
              alignItems: 'center'
            }}>
              <Button
                onClick={() => navigate('/')}
                sx={{
                  backgroundColor: 'transparent',
                  color: '#000000',
                  borderRadius: '30px',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' },
                  padding: '10px 30px',
                  fontFamily: 'Poppins',
                  fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '24px' },
                }}
              >
                {t("HomeNav4", translations, language)}
              </Button>

              <Button
                onClick={() => navigate('/personal')}
                sx={{
                  color: '#000000',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' },
                  padding: '10px 30px',
                  fontFamily: 'Poppins',
                  fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '24px' }
                }}
              >
                {t("HomeNav5", translations, language)}
              </Button>

              <Button
                onClick={() => navigate('/business')}
                sx={{
                  color: '#000000',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' },
                  padding: '10px 30px',
                  fontFamily: 'Poppins',
                  fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '24px' }
                }}
              >
                {t("HomeNav6", translations, language)}
              </Button>

              <Button
                sx={{
                  color: '#ffffff',
                  backgroundColor: '#000000',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: '#000000' },
                  padding: '10px 30px',
                  fontFamily: 'Poppins',
                  fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '24px' },
                  borderRadius: '30px'
                }}
              >
                {getTranslation('Contatti')}
              </Button>
            </Box>
          </Box>
          
          {/* Mobile Menu Button - Only visible on mobile */}
          <Box sx={{
            display: { xs: 'flex', md: 'none' },
            justifyContent: 'flex-end',
            position: 'absolute',
            top: '20px',
            right: '20px',
            zIndex: 1300  // Higher z-index to ensure it's above everything
          }}>
            <IconButton
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              sx={{
                color: mobileMenuOpen ? '#FFFFFF' : '#000000',
                padding: '12px'
              }}
            >
              <MenuIcon fontSize="large" />
            </IconButton>
          </Box>

          {/* Mobile Menu Drawer */}
          <Drawer
            anchor="right"
            open={mobileMenuOpen}
            onClose={() => setMobileMenuOpen(false)}
            sx={{
              display: { xs: 'block', md: 'none' },
              '& .MuiDrawer-paper': {
                width: '100%',
                backgroundColor: '#000000',
                color: '#ffffff',
              }
            }}
          >
            <Box sx={{ p: 2 }}>
              {/* Header with back button */}
              <Box sx={{ py: 2, display: 'flex', alignItems: 'center' }}>
                <IconButton
                  onClick={() => setMobileMenuOpen(false)}
                  sx={{ ml: 1, color: '#FFFFFF' }}
                >
                  <ArrowBackIcon />
                </IconButton>
                <Typography variant="h6" sx={{ ml: 2, color: '#FFFFFF' }}>
                  Menu
                </Typography>
              </Box>
              <Divider sx={{ backgroundColor: '#FFFFFF' }} />

              {/* Menu Items */}
              <MenuItem onClick={() => { navigate('/'); setMobileMenuOpen(false); }} sx={{ py: 2, color: '#FFFFFF', backgroundColor: 'transparent' }}>
                {t("HomeNav4", translations, language)}
              </MenuItem>
              <MenuItem onClick={() => { navigate('/personal'); setMobileMenuOpen(false); }} sx={{ py: 2, color: '#FFFFFF', backgroundColor: 'transparent' }}>
                {t("HomeNav5", translations, language)}
              </MenuItem>
              <MenuItem onClick={() => { navigate('/business'); setMobileMenuOpen(false); }} sx={{ py: 2, color: '#FFFFFF', backgroundColor: 'transparent' }}>
                {t("HomeNav6", translations, language)}
              </MenuItem>
              <MenuItem onClick={handleApriIlConto} sx={{ py: 2, color: '#FFFFFF' }}>
                {t("HomeNav2", translations, language)}
              </MenuItem>
              <MenuItem onClick={() => window.open('https://my.crhmoney.com', '_blank')} sx={{ py: 2, color: '#FFFFFF' }}>
                {t("HomeNav3", translations, language)}
              </MenuItem>
              <MenuItem onClick={() => navigate('/contact_us')} sx={{ py: 2, color: '#FFFFFF', backgroundColor: '#333333' }}>
                {getTranslation('Contatti')}
              </MenuItem>
              <MenuItem onClick={() => switchLanguage(language === 'en' ? 'it' : 'en')} sx={{ py: 2, color: '#FFFFFF' }}>
                {language === 'en' ? 'Italiano' : 'English'}
              </MenuItem>
            </Box>
          </Drawer>
        </Box>
      </Box>


      {/* Contact us box */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '70vh',
          mt: { xs: '0px', sm: '10px', md: '40px', lg: '80px' },
          pt: { xs: '0px', sm: '10px', md: '40px', lg: '80px' },
          pb: { xs: '30px', sm: '50px', md: '80px', lg: '80px' },
          background: '#000000' 
        }}
      >
        <Container>
          <Box sx={{ mb: { xs: 4, sm: 6, md: 8, lg: 10 } }}>
            <Typography
              variant="h1"
              sx={{
                fontWeight: 'bold',
                fontSize: { xs: '1.75rem', sm: '3rem', md: '3rem', lg: '3rem' },
                color: '#ffffff',
                textAlign: 'center',
              }}
            >
              {getTranslation('Contatti')}
            </Typography>
          </Box>

          <Box sx={{ mb: { xs: 4, sm: 6, md: 8, lg: 10 } }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '1rem', sm: '1.5rem', md: '1.5rem', lg: '1.5rem' },
                color: '#ffffff',
                textAlign: 'center',
              }}
            >
              {getTranslation("Il miglior modo di comunicare con noi è il seguente :")}
            </Typography>
            
            <Box sx={{ mb: { xs: 4, sm: 6, md: 8, lg: 10 } }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '1rem', sm: '1.5rem', md: '1.5rem', lg: '1.5rem' },
                  color: '#ffffff',
                  textAlign: 'center',
                  mb: 2,
                }}
              >
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  <li style={{ marginBottom: '1rem' }}>
                    <Typography
                      variant="h2"
                      sx={{
                        fontSize: { xs: '1rem', sm: '1.5rem', md: '1.5rem', lg: '1.5rem' },
                        color: '#ffffff',
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <span style={{ marginRight: '0.5rem' }}>•</span>
                      {getTranslation("Via email : servizioclienti@crhmoney.com")}
                    </Typography>
                  </li>
                  <li style={{ marginBottom: '1rem' }}>
                    <Typography
                      variant="h2"
                      sx={{
                        fontSize: { xs: '1rem', sm: '1.5rem', md: '1.5rem', lg: '1.5rem' },
                        color: '#ffffff',
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <span style={{ marginRight: '0.5rem' }}>•</span>
                      {getTranslation("Via messaggi istantanei : tramite la chat istantanea che trovi in basso a destra.")}
                    </Typography>
                  </li>
                </ul>
              </Typography>
            </Box>

            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '1rem', sm: '1.5rem', md: '1.5rem', lg: '1.5rem' },
                color: '#ffffff',
                textAlign: 'center',
                mb: 2,
              }}
            >
              {getTranslation("I messaggi saranno automaticamente inviati alle persone più idonee a risponderti e risponderemo in massimo 48 ore")}
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Contact_us;
